/**
 * @internal
 */
import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
const HiddenAccessibilityElement = forwardRef(({ as = 'div', ...props }, ref) => (React.createElement(Container, { as: as, ...props, ref: ref })));
HiddenAccessibilityElement.displayName = 'HiddenAccessibilityElement';
export default HiddenAccessibilityElement;
/**
 * `visuallyHiddenStyles` is collection of css declarations that visually hide the element but keeps it accessible for screen readers
 */
export const visuallyHiddenStyles = css `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  border: 0;
  pointer-events: none;
  white-space: nowrap;
  outline: none;
`;
// visually hidden input field (source: https://css-tricks.com/inclusively-hidden/ )
const Container = styled.div `
  ${visuallyHiddenStyles}
`;
